import { c as _c } from "react/compiler-runtime";
import { BottomSheet } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import HeaderTitle from '../../../../components/layout/components/header-title';
import type { DeviceInfo } from '../../../../hooks';
export type MissingPermissionsSheetProps = {
  device: DeviceInfo;
  open: boolean;
  onClose?: () => void;
};
const MissingPermissionsSheet = t0 => {
  const $ = _c(24);
  const {
    device,
    open,
    onClose
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "document-flow.components.missing-permissions"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv", t1);
  const {
    osName,
    type: deviceType,
    browser
  } = device;
  let t2;
  if ($[1] !== browser || $[2] !== deviceType || $[3] !== osName || $[4] !== t) {
    t2 = () => {
      if (browser.includes("Safari")) {
        return t(_temp);
      }
      if (deviceType === "mobile") {
        if (osName === "iOS") {
          return t(_temp2);
        }
        if (osName === "Android") {
          return t(_temp3);
        }
        return t(_temp4);
      }
      return t(_temp5);
    };
    $[1] = browser;
    $[2] = deviceType;
    $[3] = osName;
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const getTranslation = t2;
  let t3;
  if ($[6] !== t) {
    t3 = t(_temp6);
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t) {
    t4 = t(_temp7);
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3 || $[11] !== t4) {
    t5 = <HeaderTitle title={t3} subtitle={t4} />;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== getTranslation) {
    t6 = getTranslation();
    $[13] = getTranslation;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t6) {
    t7 = <p className="text-body-2 text-primary mt-10 text-center fp-text">{t6}</p>;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t5 || $[18] !== t7) {
    t8 = <div className="mt-4 mb-10">{t5}{t7}</div>;
    $[17] = t5;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== onClose || $[21] !== open || $[22] !== t8) {
    t9 = <BottomSheet open={open} onClose={onClose}>{t8}</BottomSheet>;
    $[20] = onClose;
    $[21] = open;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
};
export default MissingPermissionsSheet;
function _temp($) {
  return $["cta-safari"];
}
function _temp2($_0) {
  return $_0["cta-ios"];
}
function _temp3($_1) {
  return $_1["cta-android"];
}
function _temp4($_2) {
  return $_2["cta-mobile"];
}
function _temp5($_3) {
  return $_3["cta-desktop"];
}
function _temp6($_4) {
  return $_4.title;
}
function _temp7($_5) {
  return $_5.subtitle;
}